"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockBillPayConfigurationCanOverwrite = exports.mockBillPayConfigurationCannotOverwrite = exports.mockBillPayConfigurationBTHCanOverwriteLower = exports.mockBillPayConfigurationBTHCanOverwriteHigher = exports.mockBillPayConfigurationBTLCanOverwriteHigher = exports.mockBillPayConfigurationBTLCanOverwriteLower = exports.mockBillPayConfigurationZeroBalanceCanOverwrite = void 0;
exports.mockBillPayConfigurationZeroBalanceCanOverwrite = {
    can_overwrite_to_higher_amount: true,
    can_overwrite_to_lower_amount: false,
    can_overwrite_no_rent_posted: true,
    can_overwrite_past_due_rent: false,
    is_enabled: true,
};
exports.mockBillPayConfigurationBTLCanOverwriteLower = {
    can_overwrite_to_higher_amount: false,
    can_overwrite_to_lower_amount: true,
    can_overwrite_no_rent_posted: false,
    can_overwrite_past_due_rent: false,
    is_enabled: true,
};
exports.mockBillPayConfigurationBTLCanOverwriteHigher = {
    can_overwrite_to_higher_amount: true,
    can_overwrite_to_lower_amount: false,
    can_overwrite_no_rent_posted: false,
    can_overwrite_past_due_rent: false,
    is_enabled: true,
};
exports.mockBillPayConfigurationBTHCanOverwriteHigher = {
    can_overwrite_to_higher_amount: true,
    can_overwrite_to_lower_amount: false,
    can_overwrite_no_rent_posted: false,
    can_overwrite_past_due_rent: false,
    is_enabled: true,
};
exports.mockBillPayConfigurationBTHCanOverwriteLower = {
    can_overwrite_to_higher_amount: false,
    can_overwrite_to_lower_amount: true,
    can_overwrite_no_rent_posted: false,
    can_overwrite_past_due_rent: false,
    is_enabled: true,
};
exports.mockBillPayConfigurationCannotOverwrite = {
    can_overwrite_to_higher_amount: false,
    can_overwrite_to_lower_amount: false,
    can_overwrite_no_rent_posted: false,
    can_overwrite_past_due_rent: false,
    is_enabled: true,
};
exports.mockBillPayConfigurationCanOverwrite = {
    can_overwrite_to_higher_amount: true,
    can_overwrite_to_lower_amount: true,
    can_overwrite_no_rent_posted: true,
    can_overwrite_past_due_rent: false,
    is_enabled: true,
};
